import { onMessage } from "firebase/messaging";
import { messaging } from "../firebase";
import logo from "../images/logo.jpeg";

export const notificationListener = (navigate) => {
  onMessage(messaging, (payload) => {

    const notification = new Notification(
      payload.notification?.title || "New Notification",
      {
        body: payload.notification?.body || "",
        icon: logo,
      }
    );

    notification.onclick = () => {
      window.focus();

      // navigate("/Customerdetails", {
      //   state: {
      //     userId: payload.data?.userId,
      //     opponentId: payload.data?.opponentId,
      //   },
      // });
    };
  });
};